import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.scss'

const cx = classNames.bind(styles)

export type Size = 'small' | 'medium' | 'big' | 'full'
interface Props {
  size?: Size
}

const ScrollableList = (props: React.PropsWithChildren<Props>) => {
  const { children, size } = props

  return <div className={cx('scrollableList', size || 'small')}>{children}</div>
}

export default ScrollableList
